import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "show" ]

  // use decryptOnConnect if you load your autodecrypt data later via turbo frame, then the event will already be fired
  static values = {
    decryptOnConnect: {type: Boolean, default: false}
  }

  connect() {
    if (this.decryptOnConnectValue) {
      this.decrypt()
    }
  }

  async decryptElement(element) {
    const enc_data = element.dataset.encData;

    if (!enc_data || enc_data.trim() === "") {
      console.log("autodecrypt: no encData for", element.dataset.fieldKey);
      return;
    }

    if (enc_data.match("http.*encrypted_blob")) {
      console.log("ENCRYPTED BLOB");
      let src = await window.vault.decryptMessage(await(await fetch(enc_data)).text());

      if (src === null) {
        element.textContent = "NO DATA";
        return;
      }

      if (src.startsWith("data:application/pdf;")) {
        console.log("PDF detected")
        const el = document.createElement("a");
        el.setAttribute("href", src);
        el.setAttribute("target", "_blank");
        el.classList.add("text-primary", "hover:underline");
        el.innerText = "Open PDF"
        element.textContent = null;
        element.appendChild(el);
      } else {
        let img = document.createElement("img");
        let wrapper = document.createElement("div");
        console.log("Hallo Wrapper");
        img.setAttribute("src", src);
        img.style.maxWidth = "300px";
        img.style.maxHeight = "300px";
        element.textContent = null;
        element.appendChild(wrapper);
        wrapper.appendChild(img);
        wrapper.dataset.controller = "image";
      }
      return;
    }

    const plain = await window.vault.decryptMessage(enc_data.trim());

    if (plain?.startsWith("data:image/")) {
      const img = document.createElement("img");
      img.setAttribute("src", plain);
      img.style.maxWidth = "300px";
      img.style.maxHeight = "300px";
      element.textContent = null;
      element.appendChild(img);
    } else {
      if (element.tagName === "INPUT" && element.type === "text") {
        element.value = plain;
      } else {
        element.textContent = plain;
      }
    }
  }

  // decrypt will be triggered automatically if the vault is opened
  // via the `vault:vault-opened` event on window
  // fires `autodecrypt:decrypted` event when finished
  async decrypt() {
    console.log("Decrypt triggered");
    if (!window.vault.is_open()) {
      console.log("vault closed but decrypt was triggered");
      return;
    }

    for (const item of this.element.querySelectorAll(
      "[data-field-key$='_e']",
    )) {
      await this.decryptElement(item);
    }

    if (this.hasShowTarget) {
      this.showTarget.classList.remove("hidden");
    }
    console.log("Decrypt finished, dispatching 'decrypted' event.");
    this.dispatch("decrypted");
  }
}
